import { render, staticRenderFns } from "./projectRegister.vue?vue&type=template&id=3834ec35&scoped=true&"
import script from "./projectRegister.vue?vue&type=script&lang=js&"
export * from "./projectRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3834ec35",
  null
  
)

export default component.exports